// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2M47Y","validationTips":"StatementDescriptor_validationTips__2VubO"};